import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	insights: {
		id: 'software-deployments.insights-button.insights',
		defaultMessage: 'Insights',
		description:
			'Label for a button that toggles a panel containing insights/metrics for the current project.',
	},
	buttonDisabledForAdmins: {
		id: 'software-deployments.insights-button.button-disabled-for-admins',
		defaultMessage:
			'To view insights about this project, enable the View aggregated data permission in your settings.',
		description:
			'Prompt admins to go to project settings to enable the permission for viewing aggregated data so that they can use Insights.',
	},
	buttonDisabledForNonAdmins: {
		id: 'software-deployments.insights-button.button-disabled-for-non-admins',
		defaultMessage:
			'To view insights about this project, ask your project admin to enable the View aggregated data permission.',
		description: 'Prompt users to contact their admin for enabling Insights in this project.',
	},
	tooltip: {
		id: 'software-deployments.insights-button.tooltip',
		defaultMessage: 'Deployment insights',
		description: 'Tooltip describing the content that the button toggles',
	},
});
